// All code comments in English per your project standards

// Key builder: prefer departmentId; fallback to normalized department name
export function buildDeptKey(team) {
    const depId = team?.departmentId ?? null;
    if (depId) return `id:${depId}`;
    const depName = (team?.department || "").trim().toLowerCase();
    return `name:${depName || "__no_department__"}`;
}

export function buildDeptLabel(team) {
    return team?.department || "Unknown department";
}

// Return an array of duplicate departments { label: string, names: string[] }
export function findDuplicateDepartments(teams) {
    const byDept = new Map(); // key -> { label, names[] }
    for (const t of teams || []) {
        const key = buildDeptKey(t);
        const label = buildDeptLabel(t);
        const name = t?.name || "Unnamed team";
        if (!byDept.has(key)) byDept.set(key, { label, names: [name] });
        else byDept.get(key).names.push(name);
    }
    const duplicates = [];
    for (const [, v] of byDept.entries()) {
        if (v.names.length > 1) duplicates.push(v);
    }
    return duplicates;
}

export function formatDuplicateSummary(dups) {
    return dups.map((d) => `${d.label}: (${d.names.join(", ")})`).join(" | ");
}

// Convenience: returns { ok: boolean, message?: string }
export function ensureOneTeamPerDepartment(teams) {
    const dups = findDuplicateDepartments(teams);
    if (dups.length === 0) return { ok: true };
    return {
        ok: false,
        message: `There are currently multiple teams assigned to the same department, only one team can be assigned for each department. Conflicts in: ${formatDuplicateSummary(
            dups
        )}`,
    };
}
